import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const AddResourceDrawer = ({ isOpen, onClose, onSubmit }) => {
  const [title, setTitle] = useState("");
  const [files, setFiles] = useState([]);

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("title", title);

    files.forEach((file) => {
      formData.append("files", file);
    });

    onSubmit(formData);
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Add Resource</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <input
            type="file"
            multiple
            onChange={(e) => setFiles(Array.from(e.target.files))}
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row">
          <GradientButton onClick={onClose}>Cancel</GradientButton>
          <GradientButton onClick={handleSubmit}>
            Upload
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddResourceDrawer;